const RadioButtonComponentLandscapes = ({
    selectedOption,
    onSelectOption,
    options,
    className,
    disabled,
    inputClassName,
}) => {
    const handleOptionChange = (option) => {
        onSelectOption(option);
    };

    return (
        <div className={`flex  gap-3 ${className}`}>
            {options.map((option, i) => (
                <label className="cursor-pointer flex items-center" key={option?.name + i}>
                    <input
                        type="radio"
                        disabled={disabled}
                        value={option?.name}
                        checked={selectedOption === option?.name}
                        onChange={() => handleOptionChange(option)}
                        className={`hidden ${inputClassName}`}
                    />
                    <span className="bg-[#253F38] rounded-full p-2">
                        <span
                            className={`w-4 h-4 border-2 border-[#3CAB80] rounded-full flex items-center justify-center`}
                        >
                            <span
                                className={`w-2 h-2 bg-[#3CAB80] rounded-full ${
                                    selectedOption === option?.name ? 'block' : 'hidden'
                                }`}
                            ></span>
                        </span>
                    </span>

                    <span className="capitalize ml-2">{option?.name}</span>
                </label>
            ))}
        </div>
    );
};

export default RadioButtonComponentLandscapes;
